<template>
  <div class="layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style lang="scss" scoped>
.layout {
}
</style>
